module.exports = __webpack_public_path__ + "static/media/goblin_shaman_circle.5e0ad7bb.svg";